/* =====================================================================
   ProMechBC — shared front-end behaviors (Shopify port of site.js)
   Progressive enhancement only. Cart mutations are owned by Dawn's
   product-form.js / cart.js / cart-drawer.js — this file only reacts
   to them (toast, fly-dot, badge sync) and drives pure-UI chrome.
   ===================================================================== */
(function () {
  'use strict';

  /* ---- Toast ------------------------------------------------------- */
  let toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<span class="toast__check"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span class="toast__msg"></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.toast__msg').textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }
  window.pmbToast = toast;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Fly-to-cart celebration ------------------------------------ */
  function flyToCart(fromEl) {
    const cart = document.querySelector('#cart-icon-bubble, .cart-btn');
    if (!cart || reducedMotion || !fromEl || !fromEl.animate) return;
    const a = fromEl.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width || !b.width) return;
    const dot = document.createElement('span');
    dot.className = 'fly-dot';
    dot.style.left = (a.left + a.width / 2 - 7) + 'px';
    dot.style.top = (a.top + a.height / 2 - 7) + 'px';
    document.body.appendChild(dot);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy - 64) + 'px) scale(0.85)', opacity: 1, offset: 0.6 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.3)', opacity: 0.8 }
    ], { duration: 600, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }).onfinish = () => dot.remove();
  }
  window.pmbFlyToCart = flyToCart;

  /* ---- React to Dawn cart updates (pubsub.js) ---------------------- */
  /* product-form.js publishes PUB_SUB_EVENTS.cartUpdate after a
     successful add. We celebrate; Dawn owns the actual cart state. */
  let lastAtcBtn = null, lastAtcAt = 0;
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.atc-btn, [data-add-to-cart]');
    if (btn) { lastAtcBtn = btn; lastAtcAt = Date.now(); }
  }, true);

  function celebrateAdd() {
    const fresh = lastAtcBtn && Date.now() - lastAtcAt < 6000 ? lastAtcBtn : null;
    if (fresh) {
      fresh.classList.add('is-added');
      setTimeout(() => fresh.classList.remove('is-added'), 1900);
      flyToCart(fresh);
    }
    document.querySelectorAll('.cart-count-bubble, .cart-btn__count').forEach(el => {
      el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped');
    });
  }

  function hookCartEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') celebrateAdd();
    });
    return true;
  }
  /* pubsub.js is deferred like us; retry briefly in case of ordering */
  if (!hookCartEvents()) {
    let tries = 0;
    const t = setInterval(function () {
      if (hookCartEvents() || ++tries > 20) clearInterval(t);
    }, 250);
  }

  /* ---- Mobile nav (multi-step drill-in drawer) ---------------------- */
  /* Levels are emitted flat by snippets/pmb-mobile-nav.liquid and addressed by
     data-nav-panel. Navigating only swaps which level is active and pushes/pops
     a stack, so the back button always returns exactly one step. The drawer
     itself never scrolls the page: the panel is a fixed-height flex column and
     only the row list inside the active level can move, with scroll chaining
     contained so a flick never reaches the document behind it. */
  let navStack = ['root'];
  let navReturnFocus = null;

  function navRoot() { return document.querySelector('[data-mobile-nav]'); }
  function navLevel(root, id) { return root.querySelector('[data-nav-panel="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]'); }

  function paintNav(root, animate) {
    const current = navStack[navStack.length - 1];
    const back = root.querySelector('[data-nav-back]');
    const backLabel = root.querySelector('[data-nav-back-label]');

    root.querySelectorAll('[data-nav-panel]').forEach(function (level) {
      const id = level.getAttribute('data-nav-panel');
      const isActive = id === current;
      const isAncestor = !isActive && navStack.indexOf(id) !== -1;
      level.classList.toggle('is-active', isActive);
      level.classList.toggle('is-behind', isAncestor);
      level.classList.toggle('no-anim', !animate);
      /* Keep collapsed levels out of the tab order and the a11y tree. */
      if (isActive) level.removeAttribute('inert');
      else level.setAttribute('inert', '');
    });

    if (back) {
      const atRoot = navStack.length < 2;
      back.hidden = atRoot;
      if (!atRoot && backLabel) {
        const parentId = navStack[navStack.length - 2];
        const parentLevel = navLevel(root, parentId);
        const parentTitle = parentLevel && parentLevel.getAttribute('data-nav-title');
        backLabel.textContent = parentTitle || backLabel.dataset.rootLabel || 'Menu';
      }
    }
    root.classList.toggle('is-deep', navStack.length > 1);
  }

  /* Focus has to wait a frame: marking the level we just left `inert` makes the
     browser pull focus out of it, and that fixup lands on the panel if we have
     already moved focus ourselves. One rAF puts us after it. */
  function navFocus(el) {
    if (!el) return;
    requestAnimationFrame(function () { el.focus({ preventScroll: true }); });
  }

  function navGo(id) {
    const root = navRoot();
    if (!root || !navLevel(root, id)) return;
    navStack.push(id);
    paintNav(root, true);
    const level = navLevel(root, id);
    const list = level.querySelector('.mnav__list');
    if (list) list.scrollTop = 0;
    /* Land on the level itself, so screen readers announce the submenu's name
       before its rows instead of jumping straight into the first link. */
    navFocus(level);
  }

  function navBack() {
    const root = navRoot();
    if (!root || navStack.length < 2) return;
    const leaving = navStack.pop();
    paintNav(root, true);
    const opener = root.querySelector('[data-nav-open="' + (window.CSS && CSS.escape ? CSS.escape(leaving) : leaving) + '"]');
    navFocus(opener || navLevel(root, navStack[navStack.length - 1]));
  }

  function setNav(open) {
    const root = navRoot();
    if (!root) return;
    if (open) navReturnFocus = document.activeElement;
    root.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('pmb-nav-open', open);
    const toggle = document.querySelector('.nav-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));

    if (open) {
      const backLabel = root.querySelector('[data-nav-back-label]');
      /* Remember the translated root label before the first drill-in overwrites it. */
      if (backLabel && !backLabel.dataset.rootLabel) backLabel.dataset.rootLabel = backLabel.textContent.trim();
      navStack = ['root'];
      paintNav(root, false);
      const panel = root.querySelector('.mobile-nav__panel');
      if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 40);
    } else {
      /* Hand focus back to whatever opened the drawer; fall back to the burger
         button so focus is never left on a now-hidden element. */
      const restore =
        navReturnFocus && navReturnFocus.focus && navReturnFocus !== document.body
          ? navReturnFocus
          : toggle;
      if (restore) restore.focus({ preventScroll: true });
      navReturnFocus = null;
    }
  }
  window.pmbNav = setNav;

  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav-toggle, [data-open-nav]')) { e.preventDefault(); setNav(true); return; }
    if (e.target.closest('[data-close-nav]')) { setNav(false); return; }

    const branch = e.target.closest('[data-nav-open]');
    if (branch) { e.preventDefault(); navGo(branch.getAttribute('data-nav-open')); return; }

    if (e.target.closest('[data-nav-back]')) { e.preventDefault(); navBack(); }
  });

  /* Escape steps back one level first, and only closes from the root — the
     behaviour a drill-in menu is expected to have. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const root = navRoot();
    if (root && root.classList.contains('is-open') && navStack.length > 1) { navBack(); return; }
    setNav(false);
    if (window.pmbSearch) window.pmbSearch(false);
  });

  /* Keep focus inside the open drawer. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const root = navRoot();
    if (!root || !root.classList.contains('is-open')) return;
    const panel = root.querySelector('.mobile-nav__panel');
    const focusables = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    const usable = Array.prototype.filter.call(focusables, function (el) {
      return el.offsetParent !== null && !el.closest('[inert]') && !el.hidden;
    });
    if (!usable.length) return;
    const first = usable[0], last = usable[usable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  /* Mirror the header cart count into the drawer's cart button. */
  function syncNavCart() {
    const badge = document.querySelector('[data-mnav-cart-count]');
    const source = document.querySelector('#cart-icon-bubble [data-cart-count]');
    if (!badge || !source) return;
    badge.textContent = source.dataset.cartCount || '0';
  }
  const cartBubbleHost = document.getElementById('cart-icon-bubble');
  if (cartBubbleHost && 'MutationObserver' in window) {
    new MutationObserver(syncNavCart).observe(cartBubbleHost, { childList: true, subtree: true });
  }

  /* ---- Mobile bottom nav (tab bar) -------------------------------- */
  function initTabbar() {
    const tabbar = document.querySelector('.tabbar');
    if (!tabbar || tabbar.dataset.pmbInit) return;
    tabbar.dataset.pmbInit = '1';

    /* Mark the current page's tab as active (Shopify route matching) */
    const here = location.pathname.replace(/\/$/, '') || '/';
    tabbar.querySelectorAll('.tabbar__item[data-page]').forEach(function (item) {
      const routes = item.dataset.page.split(',').map(s => s.trim());
      const active = routes.some(r => r === '/' ? here === '/' : (here === r || here.indexOf(r + '/') === 0 || here.indexOf(r) === 0 && r !== '/'));
      if (active) item.setAttribute('aria-current', 'page');
    });

    /* Keep the cart badge in sync with the header cart bubble
       (#cart-icon-bubble innerHTML is re-rendered by Dawn's cart JS) */
    const badge = tabbar.querySelector('.tabbar__badge');
    const bubbleHost = document.getElementById('cart-icon-bubble');
    function readCount() {
      const el = document.querySelector('#cart-icon-bubble [data-cart-count], #cart-icon-bubble .cart-count-bubble span[aria-hidden], #cart-icon-bubble .cart-count-bubble');
      if (!el) return 0;
      const n = parseInt(el.dataset && el.dataset.cartCount != null ? el.dataset.cartCount : el.textContent, 10);
      return isNaN(n) ? 0 : n;
    }
    function syncBadge(bump) {
      if (!badge) return;
      const n = readCount();
      badge.dataset.count = String(n);
      badge.textContent = n > 99 ? '99+' : (n > 0 ? String(n) : '');
      if (bump) { badge.classList.remove('is-bumped'); void badge.offsetWidth; badge.classList.add('is-bumped'); }
    }
    syncBadge(false);
    if (bubbleHost && 'MutationObserver' in window) {
      new MutationObserver(() => syncBadge(true)).observe(bubbleHost, { childList: true, characterData: true, subtree: true });
    }

    /* The tab bar is PERMANENTLY fixed — no hide-on-scroll.
       It used to slide away on scroll-down, which broke everything anchored to
       it: `.sticky-buy` and `.pmb-cmp-dock` both offset their `bottom` by
       `--tabbar-h`, and that offset is a static token, so when the bar left the
       screen both of them stayed floating 64px above the bottom edge with page
       content running underneath. Bottom-anchored chrome that other fixed
       chrome stacks on cannot move on scroll. */
  }

  /* ---- Search overlay --------------------------------------------- */
  /* Whatever opened the overlay, so focus can be handed back to it. Closing a
     modal by dropping focus on <body> strands a keyboard user at the top of
     the document, several tab stops from the button they just pressed. */
  let searchOpener = null;

  function setSearch(open) {
    const searchOv = document.querySelector('.search-ov');
    if (!searchOv) return;
    /* No-op when already in the requested state: `setSearch(false)` fires from
       several places and each one would otherwise clear the body scroll lock
       the nav drawer might currently be holding. */
    if (open === searchOv.classList.contains('is-open')) return;

    searchOv.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';

    if (open) {
      searchOpener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      setTimeout(() => searchOv.querySelector('.search-ov__input')?.focus(), 60);
      return;
    }
    /* The drawer's search button hands over to the overlay and then closes
       with the drawer, so the opener can be gone or hidden by the time focus
       comes back — focusing a hidden element just drops focus on <body>. */
    if (searchOpener && document.contains(searchOpener) && searchOpener.offsetParent !== null) searchOpener.focus();
    searchOpener = null;
  }
  window.pmbSearch = setSearch;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) {
      e.preventDefault();
      /* The drawer carries a search button too — hand over cleanly. */
      if (window.pmbNav) window.pmbNav(false);
      setSearch(true);
      return;
    }
    const ov = e.target.closest('.search-ov');
    if (ov && (e.target.closest('[data-close-search]') || e.target.classList.contains('search-ov__scrim'))) setSearch(false);
  });

  /* Escape closes, Tab stays inside. `aria-modal="true"` is a promise to the
     screen reader that nothing outside the dialog is reachable; without a trap
     the promise is false and Tab walks off into the page behind the scrim.
     pmb-search.js consumes Escape first when a result list is open, so the
     first press dismisses the results and the second closes the overlay. */
  const SEARCH_FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Tab') return;
    const ov = document.querySelector('.search-ov.is-open');
    if (!ov) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      setSearch(false);
      return;
    }

    /* Two exclusions, both load-bearing. offsetParent drops everything inside
       a [hidden] branch — the idle panel while results are showing, and the
       results while they are not. tabIndex drops the result rows, which are
       anchors with `tabindex="-1"` because the arrow keys walk them, not Tab;
       counting one of those as the last stop would wrap the trap around an
       element Tab can never land on and let focus escape to the browser UI. */
    const stops = Array.prototype.filter.call(
      ov.querySelectorAll(SEARCH_FOCUSABLE),
      (el) => el.offsetParent !== null && el.tabIndex >= 0
    );
    if (!stops.length) return;

    const edge = e.shiftKey ? stops[0] : stops[stops.length - 1];
    if (document.activeElement !== edge) return;
    e.preventDefault();
    (e.shiftKey ? stops[stops.length - 1] : stops[0]).focus();
  });

  /* ---- Scroll reveals (data-reveal) -------------------------------- */
  const revealIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-revealed'); revealIO.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -36px' }) : null;
  function observeReveals(root) {
    const els = (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (reducedMotion || !revealIO || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    els.forEach(el => revealIO.observe(el));
  }
  window.pmbReveal = observeReveals;

  /* ---- Count-up numbers (data-count / data-decimals) ---------------- */
  function countUp(el) {
    const target = parseFloat(el.dataset.count);
    if (isNaN(target)) return;
    const dec = parseInt(el.dataset.decimals || '0', 10);
    if (reducedMotion) { el.textContent = target.toLocaleString('en-CA', { minimumFractionDigits: dec, maximumFractionDigits: dec }); return; }
    const dur = 1400, t0 = performance.now();
    function frame(t) {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 4);
      el.textContent = (target * eased).toLocaleString('en-CA', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  window.pmbCountUp = countUp;
  const countIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { countUp(en.target); countIO.unobserve(en.target); }
    });
  }, { threshold: 0.5 }) : null;
  function observeCounts(root) {
    (root || document).querySelectorAll('[data-count]:not([data-pmb-counted])').forEach(function (el) {
      el.dataset.pmbCounted = '1';
      if (countIO) countIO.observe(el); else countUp(el);
    });
  }

  /* ---- Accordions (pmb-accordion — not Dawn's) ---------------------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.pmb-accordion').forEach(function (acc) {
      if (acc.dataset.pmbInit) return;
      acc.dataset.pmbInit = '1';
      acc.querySelectorAll('.pmb-accordion__trigger').forEach(function (trigger) {
        const item = trigger.closest('.pmb-accordion__item');
        trigger.addEventListener('click', function () {
          const open = item.getAttribute('aria-expanded') === 'true';
          if (!acc.dataset.multi) {
            acc.querySelectorAll('.pmb-accordion__item[aria-expanded="true"]').forEach(i => {
              i.setAttribute('aria-expanded', 'false');
              i.querySelector('.pmb-accordion__trigger').setAttribute('aria-expanded', 'false');
            });
          }
          item.setAttribute('aria-expanded', String(!open));
          trigger.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }

  /* ---- Service pages: symptom triage tabs (pmb-svc-triage) ---------- */
  /* Panels are keyed by block id, so two symptoms may share a chip label.
     With JS off the first panel keeps its `data-active` and stays readable. */
  function initTriage(root) {
    (root || document).querySelectorAll('[data-pmb-triage]').forEach(function (wrap) {
      if (wrap.dataset.pmbInit) return;
      wrap.dataset.pmbInit = '1';
      const tabs = Array.from(wrap.querySelectorAll('[data-dx]'));
      const panels = Array.from(wrap.querySelectorAll('[data-dx-panel]'));
      if (!tabs.length) return;

      function show(key) {
        tabs.forEach(function (t) {
          const on = t.dataset.dx === key;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          if (p.dataset.dxPanel === key) p.setAttribute('data-active', '');
          else p.removeAttribute('data-active');
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { show(tab.dataset.dx); });
        tab.addEventListener('keydown', function (e) {
          let next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          e.preventDefault();
          show(tabs[next].dataset.dx);
          tabs[next].focus();
        });
      });
    });
  }

  /* ---- Battery hero: cell-health bench before/after ----------------- */
  /* Every readout carries its own data-before / data-after, so the copy
     stays in the section settings rather than being hard-coded here. */
  function initPack(root) {
    (root || document).querySelectorAll('.pmb-pack').forEach(function (pack) {
      if (pack.dataset.pmbInit) return;
      pack.dataset.pmbInit = '1';
      const buttons = Array.from(pack.querySelectorAll('[data-pack-state]'));
      if (!buttons.length) return;
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const state = btn.getAttribute('data-pack-state');
          pack.setAttribute('data-state', state);
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          pack.querySelectorAll('[data-pack-field]').forEach(function (el) {
            const value = el.getAttribute('data-' + state);
            if (value !== null) el.textContent = value;
          });
        });
      });
    });
  }

  /* ---- Service-interval dial fills when it scrolls into view -------- */
  function initDial(root) {
    (root || document).querySelectorAll('.pmb-dial').forEach(function (dial) {
      if (dial.dataset.pmbInit) return;
      dial.dataset.pmbInit = '1';
      if (reducedMotion || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
        dial.classList.add('is-revealed');
        return;
      }
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { dial.classList.add('is-revealed'); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(dial);
    });
  }

  /* ---- Generic form validation (pmb-field) -------------------------- */
  window.pmbValidateField = function (field) {
    /* Hidden branches (conditional Zoho groups) never block a submit. */
    if (field.hidden) {
      field.classList.remove('is-invalid', 'is-valid');
      return true;
    }
    /* Radio/checkbox groups: at least one option must be picked. */
    if (field.hasAttribute('data-required-group')) {
      const picked = field.querySelector('input:checked');
      field.classList.toggle('is-invalid', !picked);
      field.classList.toggle('is-valid', !!picked);
      return !!picked;
    }
    const control = field.querySelector('.pmb-input, .pmb-select, .pmb-textarea');
    if (!control) return true;
    let ok = control.checkValidity() && control.value.trim() !== '' || !control.required;
    if (control.required && control.value.trim() === '') ok = false;
    if (control.type === 'email' && control.value) ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(control.value);
    field.classList.toggle('is-invalid', !ok);
    field.classList.toggle('is-valid', ok && control.value.trim() !== '');
    return ok;
  };

  function initForms(root) {
    (root || document).querySelectorAll('form[data-validate]').forEach(function (form) {
      if (form.dataset.pmbInit) return;
      form.dataset.pmbInit = '1';
      form.querySelectorAll('.pmb-field').forEach(function (field) {
        const control = field.querySelector('.pmb-input, .pmb-select, .pmb-textarea');
        control?.addEventListener('blur', () => { if (control.value) window.pmbValidateField(field); });
        control?.addEventListener('input', () => { if (field.classList.contains('is-invalid')) window.pmbValidateField(field); });
        if (field.hasAttribute('data-required-group')) {
          field.addEventListener('change', () => { if (field.classList.contains('is-invalid')) window.pmbValidateField(field); });
        }
      });
      form.addEventListener('submit', function (e) {
        let valid = true;
        form.querySelectorAll('.pmb-field').forEach(function (field) { if (!window.pmbValidateField(field)) valid = false; });
        if (!valid) {
          e.preventDefault();
          const firstBad = form.querySelector('.pmb-field.is-invalid');
          const target = firstBad?.querySelector('.pmb-input, .pmb-select, .pmb-textarea, input');
          target?.focus();
          firstBad?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    });
  }

  /* ---- Init + theme-editor re-init ---------------------------------- */
  function initAll(root) {
    initTabbar();
    observeReveals(root);
    observeCounts(root);
    initAccordions(root);
    initForms(root);
    initTriage(root);
    initPack(root);
    initDial(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
